<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer003">
<p class="ebook-toc" id="_idParaDest-1"><a id="_idTextAnchor000"></a> </p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer004">
<p class="Normal ParaOverride-1"><span class="CharOverride-1">Recent Collections</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Virtual Doonesbury</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Planet Doonesbury</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Buck Wild Doonesbury</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Duke 2000: Whatever It Takes</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">The Revolt of the English Majors</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Peace Out, Dawg!</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Got War?</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Talk to the Hand</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Heckuva Job, Bushie!</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Welcome to the Nerd Farm!</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Tee Time in Berzerkistan</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Red Rascal’s War</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Squared Away</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">The Weed Whisperer</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Yuge!: 30 Years of Doonesbury on Trump</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">#SAD!: Doonesbury in the Time of Trump</span></p>
<p class="Normal ParaOverride-1 t"><span class="CharOverride-1">Anthologies</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">The Doonesbury Chronicles</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Doonesbury’s Greatest Hits</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">The People’s Doonesbury</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Doonesbury Dossier: The Reagan Years</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Doonesbury Deluxe: Selected Glances Askance</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Recycled Doonesbury: Second Thoughts on a Gilded Age</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">The Portable Doonesbury</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">The Bundled Doonesbury</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">40: A Doonesbury Retrospective</span></p>
<p class="Normal ParaOverride-1 t"><span class="CharOverride-1">Special Collections</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Flashbacks: Twenty-Five Years of Doonesbury </span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Action Figure!: The Life and Times of Doonesbury’s Uncle Duke</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Dude: The Big Book of Zonker</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">The Sandbox: Dispatches from Troops in Iraq and Afghanistan</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">The War in Quotes</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">“My Shorts R Bunching. Thoughts?”: The Tweets of Roland Hedley</span></p>
<p class="Normal ParaOverride-1 t"><span class="CharOverride-1">Wounded Warrior Series</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">The Long Road Home: One Step at a Time</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">The War Within: One More Step at a Time</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Signature Wound: Rocking TBI</span></p>
<p class="Normal ParaOverride-1"><span class="CharOverride-2">Mel’s Story: Surviving Military Sexual Assault</span></p>
</div>
<div class="_idGenObjectLayout-1">
<div id="_idContainer005">
<img alt="" class="_idGenObjectAttribute-1" src="image/title.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LEWSER_epub-1.vue?50c65e83